module.exports = __webpack_public_path__ + "static/media/tv-1b.c788725c.jpg";